import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import { Message } from 'semantic-ui-react';

export type Props = {
    title: string;
    content?: string | React.ReactElement;
    visible?: boolean;
};

export default class ErrorMessage extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { title, content, visible } = this.props;

        return (
            <Message error visible={visible} className="error-message">
                <Message.Header>
                    <div className="icon" aria-hidden>
                        <ErrorIcon
                            htmlColor="rgb(245, 34, 45)"
                            style={{
                                fontSize: 25
                            }}
                        />
                    </div>
                    {title}
                </Message.Header>
                {content && <Message.Content>{content}</Message.Content>}
            </Message>
        );
    }
}
